import { cn } from 'library/utils';
import React from 'react';
import { Badge as BadgeStrap } from 'reactstrap';
import { Badge as BadgeShadcn } from 'components/ui/badge';

/**
 *
 * @param {Object} props
 * @param {"primary" | "success" | "warning" | "danger" | "secondary"} props.color
 * @param {string} props.className
 * @param {Object} props.style
 * @param {boolean} props.v2 - will use from shadcn
 * @returns
 */
const Badge = ({ children, style, className, color = 'primary', useV1 = false, v2 = false }) => {
  //! State

  //! Function
  const badgeColors = {
    pending: 'primary',
    processing: 'warning',
    success: 'success',
    danger: 'danger',
    secondary: 'secondary',
  };

  //! Render
  if (v2) {
    const mappingColor = {
      primary: 'default',
      success: 'success',
      warning: 'warning',
      danger: 'destructive',
      secondary: 'secondary',
    };
    return (
      <BadgeShadcn variant={mappingColor[color]} className={className} style={style}>
        {children}
      </BadgeShadcn>
    );
  }

  if (useV1) {
    return (
      <BadgeStrap
        className={className}
        style={style}
        color={badgeColors?.[color] || color || 'primary'}
      >
        {children}
      </BadgeStrap>
    );
  }

  const typeTag = () => {
    const mapping = {
      success: {
        color: 'var(--color-green-7-v2)',
        background: 'var(--color-green-1-v2)',
        borderColor: 'var(--color-green-3-v2)',
      },
      primary: {
        color: 'var(--color-red-7-v2)',
        background: 'var(--color-red-1-v2)',
        borderColor: 'var(--color-red-3-v2)',
      },
      pending: {
        color: 'var(--color-blue-7-v2)',
        background: 'var(--color-blue-1-v2)',
        borderColor: 'var(--color-blue-3-v2)',
      },
      danger: {
        color: 'var(--color-red-7-v2)',
        background: 'var(--color-red-1-v2)',
        borderColor: 'var(--color-red-3-v2)',
      },
      warning: {
        color: 'var(--color-gold-7-v2)',
        background: 'var(--color-gold-1-v2)',
        borderColor: 'var(--color-gold-3-v2)',
      },
      processing: {
        color: 'var(--color-gold-7-v2)',
        background: 'var(--color-gold-1-v2)',
        borderColor: 'var(--color-gold-3-v2)',
      },
      secondary: {
        color: '#2f353a',
        background: '#e2e5e8',
        borderColor: '#2f353a',
      },
      dark: {
        color: '#2f353a',
        background: '#e2e5e8',
        borderColor: '#2f353a',
      },
    };

    return mapping[color];
  };

  //! Render
  if (!children) {
    return null;
  }

  return (
    <div
      className={cn('component:Tag badge-v2 tw-m-0', className)}
      style={{
        borderRadius: 4,
        padding: '4px 6px',
        lineHeight: 1.5,
        fontSize: 13,
        display: 'inline-block',
        border: '1px solid',
        textAlign: 'center',
        ...typeTag(),
        ...style,
      }}
    >
      {children}
    </div>
  );
};

export default React.memo(Badge);
